import { useState, useCallback } from 'react';

const STORAGE_KEY = 'aria_academy_progress';

const LEVELS = [
  { level: 1, title: 'AI Curious',       minXp: 0    },
  { level: 2, title: 'AI Aware',         minXp: 200  },
  { level: 3, title: 'AI Practitioner',  minXp: 500  },
  { level: 4, title: 'AI Consultant',    minXp: 1000 },
  { level: 5, title: 'AI Strategist',    minXp: 2000 },
  { level: 6, title: 'AI Expert',        minXp: 3500 },
  { level: 7, title: 'Certified AI Consultant', minXp: 5000 },
];

function loadProgress() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch (e) {}
  return { xp: 0, streak: 0, completedLessons: [], lastActive: null };
}

function saveProgress(progress) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(progress));
  } catch (e) {}
}

export function useProgress() {
  const [progress, setProgress] = useState(loadProgress);

  const completeLesson = useCallback((lessonId, xp = 100) => {
    setProgress(prev => {
      if (prev.completedLessons.includes(lessonId)) return prev;
      const today = new Date().toDateString();
      const streak = prev.lastActive === today ? prev.streak : prev.streak + 1;
      const next = {
        ...prev,
        xp: prev.xp + xp,
        streak,
        completedLessons: [...prev.completedLessons, lessonId],
        lastActive: today,
      };
      saveProgress(next);
      return next;
    });
  }, []);

  const addXp = useCallback((amount) => {
    setProgress(prev => {
      const next = { ...prev, xp: prev.xp + amount };
      saveProgress(next);
      return next;
    });
  }, []);

  const getLevel = useCallback(() => {
    const xp = progress.xp;
    let current = LEVELS[0];
    for (const lvl of LEVELS) {
      if (xp >= lvl.minXp) current = lvl;
    }
    const nextLvl = LEVELS.find(l => l.minXp > xp);
    return {
      ...current,
      nextLevel: nextLvl || null,
      xpToNext: nextLvl ? nextLvl.minXp - xp : 0,
      progress: nextLvl
        ? Math.round(((xp - current.minXp) / (nextLvl.minXp - current.minXp)) * 100)
        : 100,
    };
  }, [progress.xp]);

  return { progress, completeLesson, addXp, getLevel };
}
